export function BylawFramework() {
  const frameworkAreas = [
    {
      title: 'Current Status',
      items: [
        'Surrey is developing comprehensive STR regulations as part of broader housing strategy',
        'Interim guidelines require business license for all short-term rental operations',
        'Zoning bylaws currently govern permitted uses in residential areas',
        'City actively monitoring STR activity and preparing formal regulatory framework'
      ]
    },
    {
      title: 'Zoning Considerations',
      items: [
        'RS (Single Family Residential) zones have specific home-based business restrictions',
        'RM (Multiple Family Residential) zones may have strata or building-specific rules',
        'Commercial and mixed-use zones generally more permissive for STR operations',
        'Agricultural Land Reserve (ALR) properties subject to additional provincial restrictions'
      ]
    },
    {
      title: 'Business License Requirements',
      items: [
        'All STR operators must obtain City of Surrey business license',
        'Home-based business license category typically applies to residential STRs',
        'Annual renewal required with updated property and insurance information',
        'License must be displayed in rental listing and available for inspection'
      ]
    },
    {
      title: 'Property Standards',
      items: [
        'Must comply with BC Building Code and Fire Code requirements',
        'Smoke and carbon monoxide detectors required in all sleeping areas',
        'Emergency exit plans and fire extinguishers must be provided',
        'Regular safety inspections may be required for licensed operations'
      ]
    },
    {
      title: 'Strata & Landlord Permissions',
      items: [
        'Strata corporations can prohibit or restrict STRs through bylaws',
        'Written strata approval required before operating STR in strata property',
        'Rental properties require explicit landlord permission for subletting',
        'Mortgage and insurance providers must be notified of STR use'
      ]
    },
    {
      title: 'Tax Obligations',
      items: [
        'Municipal and Regional District Tax (MRDT) of 3% applies to Surrey STRs',
        'Provincial Sales Tax (PST) of 8% on accommodation under 30 days',
        'Income must be reported to Canada Revenue Agency (CRA)',
        'GST/HST registration required if annual revenue exceeds $30,000'
      ]
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Surrey's Flexible Bylaw Framework
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Understanding Surrey's current regulations and emerging framework is essential for compliant STR operations in this growing market.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {frameworkAreas.map((area, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all"
            >
              <h3 className="text-2xl font-semibold text-[#505A5A] mb-6 flex items-center">
                <span className="w-2 h-8 bg-[#882629] rounded-full mr-4"></span>
                {area.title}
              </h3>
              <ul className="space-y-4">
                {area.items.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-[#882629] text-xl mr-3 flex-shrink-0 mt-0.5"></i>
                    <span className="text-[#505A5A]/80 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-2xl p-8 shadow-md border-l-4 border-[#882629]">
          <p className="text-[#505A5A]/70 italic">
            <strong className="text-[#505A5A] not-italic">Important:</strong> Surrey's STR regulations are evolving. The City is expected to introduce more comprehensive bylaws in 2026. Stay informed about regulatory changes and ensure ongoing compliance with current and future requirements.
          </p>
        </div>
      </div>
    </section>
  );
}
